import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
const NAV_LINKS = [{
  to: '/about',
  label: 'About'
}, {
  to: '/switch',
  label: 'Switch'
}, {
  to: 'https://ai.andoe.work/',
  label: 'Login',
  external: true
}];
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isCodeMode, setIsCodeMode] = useState(false);
  const [isExpanded, setIsExpanded] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.sessionStorage.getItem('pill-expanded') === '1';
  });
  const location = useLocation();
  useEffect(() => {
    if (typeof window === 'undefined') return;
    window.sessionStorage.setItem('pill-expanded', isExpanded ? '1' : '0');
  }, [isExpanded]);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 30);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const toggleCodeMode = () => {
    const html = document.documentElement;
    html.classList.toggle('code-mode');
    setIsCodeMode(html.classList.contains('code-mode'));
  };
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'm' && !e.metaKey && !e.ctrlKey && !e.altKey) {
        const tag = document.activeElement?.tagName;
        if (tag !== 'INPUT' && tag !== 'TEXTAREA') {
          toggleCodeMode();
        }
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);
  const handlePillClick = (e: React.MouseEvent<HTMLDivElement>) => {
    // Collapse only when clicking the bare pill background, not its children
    if (e.target === e.currentTarget) {
      setIsExpanded(false);
    }
  };
  return <div className="pill-zone" data-id="element-35">
      <div className={`pill-nav ${isScrolled ? 'scrolled' : ''} ${isExpanded ? 'is-expanded' : ''}`} onMouseEnter={() => setIsExpanded(true)} onFocus={() => setIsExpanded(true)} onClick={handlePillClick} data-id="element-36">
        <Link to="/" className="brand" data-id="element-37">
          <img src="https://cdn.magicpatterns.com/uploads/kMLXsbPAjg71QNTSKitDDZ/Group_75_(3).png" alt="Andoe" style={{
          height: '22px',
          width: 'auto'
        }} data-id="element-38" />
        </Link>

        <button className="pill-chevron" aria-label={isExpanded ? 'Collapse menu' : 'Expand menu'} aria-expanded={isExpanded} onClick={e => {
        e.stopPropagation();
        setIsExpanded(v => !v);
      }} data-id="element-39">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-40">
            <polyline points="9 6 15 12 9 18" data-id="element-41" />
          </svg>
        </button>

        <div className="pill-divider" aria-hidden="true" data-id="element-42" />

        <nav className="pill-links" aria-label="Primary" data-id="element-43">
          {NAV_LINKS.map((link, i) => {
          const active = location.pathname === link.to;
          const style = {
            transitionDelay: `${60 + i * 40}ms`
          };
          if (link.external) {
            return <a key={link.to} href={link.to} target="_blank" rel="noopener noreferrer" className="pill-link" style={style} data-id="element-44">
                  {link.label}
                </a>;
          }
          return <Link key={link.to} to={link.to} className={`pill-link ${active ? 'is-active' : ''}`} style={style} data-id="element-45">
                {link.label}
              </Link>;
        })}
        </nav>

        <button className="toggle" onClick={toggleCodeMode} aria-label="Toggle view" data-id="element-46">
          <span className="toggle-knob" data-id="element-47">
            <svg className="toggle-icon-sun" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-48">
              <circle cx="12" cy="12" r="4" data-id="element-49" />
              <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" data-id="element-50" />
            </svg>
            <svg className="toggle-icon-code" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" data-id="element-51">
              <polyline points="16 18 22 12 16 6" data-id="element-52" />
              <polyline points="8 6 2 12 8 18" data-id="element-53" />
            </svg>
          </span>
        </button>
      </div>
    </div>;
}